import React, { useContext, useState } from "react";
import {
  ListGroup,
  ListGroupItem,
  Button,
  Col,
  Row,
} from "reactstrap";
import {
  Bell,
  ShoppingBag,
  DollarSign,
  CheckCircle,
  XCircle,
  Bookmark,
  BookOpen,
} from "react-feather";
import moment from "moment";
import "./notification.style.css";
import { NotificationContext } from "./NotificationContext";

const NotificationIconMap = {
  new_order: <ShoppingBag size={18} />,
  subscription: <Bookmark size={18} />,
  class: <BookOpen size={18} />,
  payout_approved: <CheckCircle size={18} color="green" />,
  payout_rejected: <XCircle size={18} color="red" />,
  banner_approved: <CheckCircle size={18} color="green" />,
  banner_rejected: <XCircle size={18} color="red" />,
};

const NotificationTypeColors = {
  new_order: "#0d6efd", // Blue
  subscription: "#198754", // Green
  class: "#ffc107", // Yellow
  payout_approved: "#28a745", // Green
  payout_rejected: "#dc3545", // Red
  banner_approved: "#28a745", // Green
  banner_rejected: "#dc3545", // Red
};

const NotificationBgColorMap = {
  new_order: "#e7f1ff", // light blue
  subscription: "#e6ffe6", // light green
  class: "#fffbea", // light yellow
  payout_approved: "#e6ffe6", // light green
  payout_rejected: "#ffe6e6", // light red
  banner_approved: "#e6ffe6", // light green
  banner_rejected: "#ffe6e6", // light red
};

const NotificationsPanel = () => {
  const { notifications, markAsRead, markAllAsRead } = useContext(NotificationContext);
  const [visibleCount, setVisibleCount] = useState(5);

  const showMore = () => setVisibleCount((prev) => prev + 5);

  return (
    <Col xl="12">
      {notifications.length > 0 && (
        <Row className="mb-3 align-items-center justify-content-between">
          <Button color="success" size="sm" onClick={markAllAsRead}>
            Mark All as Read
          </Button>
        </Row>
      )}
      {notifications.length === 0 && (
        <Row className="d-flex flex-column align-items-center justify-content-center text-center py-5 animate-notification-empty">
          <div className="notification-illustration mb-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              fill="none"
              className="w-100"
            >
              <circle cx="32" cy="32" r="30" fill="#E0F7FA" />
              <path
                d="M32 12C24.268 12 18 18.268 18 26V34L14 38V40H50V38L46 34V26C46 18.268 39.732 12 32 12Z"
                fill="#33bdbf"
              />
              <circle cx="32" cy="48" r="4" fill="#1a7f7f" />
            </svg>
          </div>
          <h5 className="text-muted fw-semibold">You're all caught up!</h5>
          <p className="text-secondary mb-0" style={{ maxWidth: "300px" }}>
            You don’t have any notifications at the moment. We’ll keep you updated!
          </p>
        </Row>
      )}
      <ListGroup flush>
        {notifications.slice(0, visibleCount).map((item) => {
          const borderColor = NotificationTypeColors[item.type] || "#0d6efd";
          const iconBg = NotificationBgColorMap[item.type] || "#f8f9fa";
          return (
            <ListGroupItem
              key={item._id}
              className="d-flex justify-content-between align-items-center mb-2 p-3"
              style={{
                backgroundColor: item.isRead ? "#fff" : "#f0f9ff",
                borderRight: item.isRead ? "none" : "4px solid #0d6efd",
                borderLeft: `4px solid ${borderColor}`,
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
              }}
            >
              <div className="d-flex align-items-start">
                <div
                  style={{
                    marginRight: "1rem",
                    padding: "0.5rem",
                    borderRadius: "50%",
                    backgroundColor: iconBg,
                    height: "40px",
                    width: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {NotificationIconMap[item.type] || <Bell size={18} />}
                </div>
                <div>
                  <div style={{ fontWeight: item.isRead ? 400 : 600 }}>
                    {item.title || "Untitled Notification"}
                  </div>
                  {item.body && <small>{item.body}</small>}
                  <small className="text-muted">
                    {moment(item.createdAt).fromNow()}
                  </small>
                </div>
              </div>
              {!item.isRead && (
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => markAsRead(item._id)}
                >
                  Mark Read
                </Button>
              )}
            </ListGroupItem>
          );
        })}
      </ListGroup>
      {visibleCount < notifications.length && (
        <Button
          color="outline"
          outline
          size="sm"
          className="mt-3"
          onClick={showMore}
        >
          Show More
        </Button>
      )}
    </Col>
  );
};

export default NotificationsPanel;